






































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BasePagination from '@/base/BasePagination.vue';
import TheTableCategories from '@/components/categories/TheTableCategories.vue';
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
// Importing function
import {getCategories} from '@/ts/categories/get-categories';

export default {
    name: 'PageCategories',
    components: {
        LayoutApp,
        BaseCard,
        BasePagination,
        TheTableCategories,
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            items: Array(),
            search_param: String(),
        };
    },
    methods: {},
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Категории',
        }];
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        this.$store.dispatch('setCurrentPage', 1);
        this.$store.dispatch('setLastPage', 1);
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getCategories(this.$route.params.id).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
